ACC.productDetail = {

    _autoload: [
        "initPageEvents",
        "bindVariantOptions",
        "configureProductCheckbox",
        "checkConfigurableInput",
        "keyupConfigInput",
        "triggerPopinRef"
    ],

    checkQtySelector: function (self, mode) {
        var input = $(self).parents(".js-qty-selector").find(".js-qty-selector-input");
        var inputVal = parseInt(input.val());
        var max = input.attr("data-max");
        var minusBtn = $(self).parents(".js-qty-selector").find(".js-qty-selector-minus");
        var plusBtn = $(self).parents(".js-qty-selector").find(".js-qty-selector-plus");

        $(self).parents(".js-qty-selector").find(".btn").removeAttr("disabled");

        if (mode == "minus") {
            if (inputVal != 1) {
                // ACC.productDetail.updateQtyValue(self, inputVal - 1)
                if (inputVal - 1 == 1) {
                    minusBtn.attr("disabled", "disabled")
                }

            } else {
                minusBtn.attr("disabled", "disabled")
            }
        } else if (mode == "reset") {
            // ACC.productDetail.updateQtyValue(self, 1)

        } else if (mode == "plus") {
        	if(max == "FORCE_IN_STOCK") {
        		// ACC.productDetail.updateQtyValue(self, inputVal + 1)
        	} else if (inputVal <= max) {
                // ACC.productDetail.updateQtyValue(self, inputVal + 1)
                if (inputVal + 1 == max) {
                    plusBtn.attr("disabled", "disabled")
                }
            } else {
                plusBtn.attr("disabled", "disabled")
            }
        } else if (mode == "input") {
            if (inputVal == 1) {
                minusBtn.attr("disabled", "disabled")
            } else if(max == "FORCE_IN_STOCK" && inputVal > 0) {
            	// ACC.productDetail.updateQtyValue(self, inputVal)
            } else if (inputVal == max) {
                plusBtn.attr("disabled", "disabled")
            } else if (inputVal < 1) {
                // ACC.productDetail.updateQtyValue(self, 1)
                // minusBtn.attr("disabled", "disabled")
            } else if (inputVal > max) {
                // ACC.productDetail.updateQtyValue(self, max)
                plusBtn.attr("disabled", "disabled")
            }
        } else if (mode == "focusout") {
        	if (isNaN(inputVal)){
                // ACC.productDetail.updateQtyValue(self, 1);
                // minusBtn.attr("disabled", "disabled");
            } else if(inputVal >= max) {
                plusBtn.attr("disabled", "disabled");
            }
        }

    },

    // updateQtyValue: function (self, value) {
    //     var input = $(self).parents(".js-qty-selector").find(".js-qty-selector-input");
    //     var addtocartQty = $(self).parents(".addtocart-component").find("#addToCartForm").find(".js-qty-selector-input");

    //     input.val(value);
    //     addtocartQty.val(value);
    // },

    initPageEvents: function () {
        $(document).on("click", '.js-qty-selector .js-qty-selector-minus', function () {
            ACC.productDetail.checkQtySelector(this, "minus");
        })

        $(document).on("click", '.js-qty-selector .js-qty-selector-plus', function () {
            ACC.productDetail.checkQtySelector(this, "plus");
        })

        $(document).on("keydown", '.js-qty-selector .js-qty-selector-input', function (e) {
            if (($(this).val() != " " && ((e.which >= 48 && e.which <= 57 ) || (e.which >= 96 && e.which <= 105 ))  ) || e.which == 8 || e.which == 46 || e.which == 37 || e.which == 39 || e.which == 9) {
            }
            else if (e.which == 38) {
                ACC.productDetail.checkQtySelector(this, "plus");
            }
            else if (e.which == 40) {
                ACC.productDetail.checkQtySelector(this, "minus");
            }
            else {
                e.preventDefault();
            }
        })

        $(document).on("keyup", '.js-qty-selector .js-qty-selector-input', function (e) {
            if(!e.shiftKey){
                var innerval = parseInt($(this).val());
                ACC.productDetail.checkQtySelector(this, "input");
                // ACC.productDetail.updateQtyValue(this, $(this).val());
                var orderval = parseInt($(this).data('maxOrder'));
                if(orderval < innerval && $("input[name=configureProduct]").is(':checked') == false){
                    $(".msg-max-stock").show();
                }
                if(parseInt($(this).data('max')) < innerval) {
                    $(".availability-message-block").removeClass('invisible');
                } else {
                    $(".msg-max-stock").hide();
                }
            }
        })

        $(document).on("focusout", '.js-qty-selector .js-qty-selector-input', function (e) {
            ACC.productDetail.checkQtySelector(this, "focusout");
            // ACC.productDetail.updateQtyValue(this, $(this).val());
        })

        $("#Size").change(function () {
            changeOnVariantOptionSelection($("#Size option:selected"));
        });

        $("#variant").change(function () {
            changeOnVariantOptionSelection($("#variant option:selected"));
        });

        $(".selectPriority").change(function () {
            window.location.href = $(this[this.selectedIndex]).val();
        });

        ACC.productDetail.bindBackForward();

        function changeOnVariantOptionSelection(optionSelected) {
            window.location.href = optionSelected.attr('value');
        }
    },

    bindVariantOptions: function () {
        ACC.productDetail.bindCurrentStyle();
        ACC.productDetail.bindCurrentSize();
        ACC.productDetail.bindCurrentType();
    },

    bindBackForward: function () {
    	if (window.performance === undefined) {
    		    return;
    		  }
    	var perfEntries = window.performance.getEntriesByType("navigation");

    	if (perfEntries[0] !== undefined && perfEntries[0].type === "back_forward") {
    	    location.reload(true);
    	}
    },

    bindCurrentStyle: function () {
        var currentStyle = $("#currentStyleValue").data("styleValue");
        var styleSpan = $(".styleName");
        if (currentStyle != null) {
            styleSpan.text(": " + currentStyle);
        }
    },

    bindCurrentSize: function () {
        var currentSize = $("#currentSizeValue").data("sizeValue");
        var sizeSpan = $(".sizeName");
        if (currentSize != null) {
            sizeSpan.text(": " + currentSize);
        }
    },

    bindCurrentType: function () {
        var currentSize = $("#currentTypeValue").data("typeValue");
        var sizeSpan = $(".typeName");
        if (currentSize != null) {
            sizeSpan.text(": " + currentSize);
        }
    },

    configureProductCheckbox: function(){
    	$(document).on("change", 'input[name=configureProduct]', function (e) {
            $('.js-amds-checkCertif_product').addClass('hidden');
            $('.postPriceHT, .right-col .select-arrow, .right-col .price-details ').addClass('hidden');
            $('.productWeightValue').text('');

    		if($(this).is(':checked'))
    		{
    			$('.jsConfigurableInput.active').prop('disabled', false);
    			$('.configurableSelect.active').removeClass("disabled");
                ACC.productDetail.checkConfigurableInput();
    		}
    		else
    		{
    			$('.jsConfigurableInput').prop('disabled', true);
    			$('.configurableSelect').addClass("disabled");
    			$('.configurableSelect.active').removeClass("checked");
    			$('.configurableSelect.active input').prop('checked', false);

                $('.js-qty-selector-input').attr('data-max', $('.js-qty-selector-input').data('maxor'));
                ACC.productDetail.checkConfigurableInput();

                if(!$(".transferTimePdp").hasClass("hidden")) {
                   $(".transferTimePdp").addClass("hidden");
                   $(".addToCartButton").removeClass("transfer");
                    }
    		}
    		ACC.productDetail.cleanCartInfos();
    		ACC.product.setConfigurableFacetStatus();
            ACC.productDetail.checkConfigurableInput();
    	});
    },

    checkConfigurableInput: function () {
        var configtrait = $(".variant-element.conf-js").find("fieldset#OO32 .configurableSelect.active");

        let isConfigurable = configtrait.hasClass("checked") || !$(".jsConfigurableInput").val() == "";
        if (isConfigurable) {
            $("button.normal-add").removeClass("hidden");
            $("button.quotation-add").addClass("hidden");
            $('.dispo-stock.dispo-stock-normal').addClass("hidden-stock");
            $('.js-product').addClass("hidden");
            $(".js-configurable-product").removeClass("hidden");
            $(".quantity-product-label").removeClass("hidden");
            $(".price-table .select-options li").removeClass("selected");
            $(".price-table").addClass("no-limit");
            // Remove tooltips
            $('.js-qty-selector-input').removeClass('tooltip');
            $('.addToCartButton').removeClass('tooltip');
            $('.tooltip-text').removeClass('tooltip-text');

        } else {
            $('.dispo-stock.dispo-stock-normal').removeClass('hidden-stock');
            $(".quantity-product-label").addClass("hidden");
            $('.js-product').removeClass("hidden");
            $(".js-configurable-product").addClass("hidden");
            $(".price-table").removeClass("no-limit");
            $('.d-input').addClass('tooltip-text');
           // $('.addToCartButton').addClass('tooltip');
        }

                configtrait.each(function(index){
                    var $this = $(this);

                    $this.on('change', function () {
                        if ($this.find("input").is(':checked') || !$(".jsConfigurableInput").val() == '') {
                            $('.dispo-stock.dispo-stock-normal').addClass("hidden-stock");
                            $('.js-product').addClass("hidden");
                            $(".quantity-product-label").removeClass("hidden");
                            $(".js-configurable-product").removeClass("hidden");
                            $(".price-table .select-options li").removeClass("selected");
                            $(".price-table").addClass("no-limit");


                            $("button.normal-add").removeClass("hidden");
                            $("button.quotation-add").addClass("hidden");

                        }else{
                            $('.dispo-stock.dispo-stock-normal').removeClass('hidden-stock');
                            $(".quantity-product-label").addClass("hidden");
                            $('.js-product').removeClass("hidden");
                            $(".js-configurable-product").addClass("hidden");
                            $(".price-table .select-options li[rel='pieces']").addClass("selected");
                            $(".price-table").removeClass("no-limit");
                        }
                    });

                })
    },

    keyupConfigInput: function () {
        $('.jsConfigurableInput').on('keyup', function() {
            ACC.productDetail.checkConfigurableInput();
        });

        $(".configurations-values .configurableSelect.active input").on('change', function () {
            ACC.productDetail.checkConfigurableInput();
        })
    },

    cleanCartInfos: function () {
    	if($('.add_to_cart_form').length > 0)
    	{
	      	var qtyInput = $('.js-qty-selector-input');
	      	$('.add_to_cart_form')[0].reset();
	      	ACC.product.prevQty = 0;
	        qtyInput.val('');
	        $('.productPrices').addClass('hidden');
	        $('.productWeight').addClass('hidden');
			$('.productLength').addClass('hidden');
	        $('.productNoPrice').addClass('hidden');
			$('.productEuroT').addClass('hidden');
			$('.productEuroM').addClass('hidden');
   		 	$('.extra-table-bloc').addClass('hidden');
	        $('#addToCartButton').attr("disabled", "disabled");
    	}
    },

    enableAddToCart: function () {
		// $('.dispo-stock').addClass("hidden-stock");
		$('.js-addToFavorite').addClass("hidden");
		$('.js-product-details').addClass("hidden");
		if($('#alertMeWhenProductInStock').length != 0)
		{
			$('.js-qty-selector-input').prop('disabled', false);
			$('#alertMeWhenProductInStock').addClass('hidden');
            $('.js-qty-selector-input').attr('data-max',9999);
		}
		/*if($('.outOfPrice').length != 0)
		{
			$('.js-qty-selector-input').prop('disabled', false);
			$('#addToCartButton.outOfPrice').removeClass('disabled');
		}*/
		if($('#configurableProduct').val() || $('#configurableProductPdp').val())
		{  $("button.normal-add").removeClass("hidden");
            $("button.quotation-add").addClass("hidden");
			$('.js-qty-selector-input').prop('disabled', false);
			if($('.js-add-to-cart.outOfStock').length != 0)
			{
			  $('.js-add-to-cart.outOfStock ').prop('disabled', false);
			  $('.js-add-to-cart.outOfStock ').addClass('addToCartButton');
			  $('.js-add-to-cart.outOfStock ').removeClass('addToCartBtnNotVariant');
			  $('.js-add-to-cart.outOfStock ').removeClass('hidden');
			  $('.js-add-to-cart.outOfStock ').removeAttr("type").attr("type", "submit");
			}
			$('.js-qty-selector-input').attr('data-max',9999);
		}


    },

    disableAddToCart: function () {

		$('.js-addToFavorite').removeClass("hidden");
		$('.js-product-details').removeClass("hidden");


		if($('#alertMeWhenProductInStock').length != 0)
		{
			$('.js-qty-selector-input').prop('disabled', true);
			$('#alertMeWhenProductInStock').removeClass('hidden');
			if($('#addToCartButton').length != 0)
			{
			  $('#addToCartButton').addClass('hidden');
			}
			$('.js-qty-selector-input').attr('data-max',0);
		}
		/*if($('.outOfPrice').length != 0)
		{
			$('.js-qty-selector-input').prop('disabled', true);
			$('#addToCartButton.outOfPrice').addClass('disabled');
		}*/
		if($('#configurableProduct').val())
		{

			if($('.js-add-to-cart.outOfStock').length != 0)
			{
				$('.js-qty-selector-input').prop('disabled', true);
				$('.js-add-to-cart.outOfStock ').prop('disabled', true);
				  $('.js-add-to-cart.outOfStock ').removeClass('addToCartButton');
				  $('.js-add-to-cart.outOfStock ').addClass('addToCartBtnNotVariant');
				$('.js-add-to-cart.outOfStock ').removeAttr("type").attr("type", "button");
				  $('.js-add-to-cart.outOfStock ').addClass('hidden');
			}
		}


    },

    triggerPopinRef: function () {
        $(document).on("click",".js-link-add-edit-ref",function(e){
            e.preventDefault();
            ACC.productDetail.refProdPopin();
        });      
    },

    refProdPopin: function () {

        ACC.colorbox.open("", {
            href: "#w-form-ref-pdp",
            inline: true,
            width: "540px",
			height: "400px",
            
            onComplete: function () {
                $(".prod-ref").removeClass("error");
                $(".errorRef").addClass("hidden");
                $(document).on("submit", '#w-form-ref-pdp', function (e) {
                    e.preventDefault();
                    $(".prod-ref").removeClass("error");
                    $(".errorRef").addClass("hidden");
                    var $form = $('#w-form-ref-pdp .formAddRef');
                    var valueText = $("#productReference").val();
                    if (valueText.length > 35) {
                        $(".prod-ref").addClass("error");
                        $(".errorRef").addClass("hidden");
                        $(".length-error").removeClass("hidden");
                        return false;
                    }else {
                        $(".prod-ref").removeClass("error");
                        $(".errorRef").addClass("hidden");
                        $.ajax({
                            url: ACC.config.encodedContextPath + $form.attr("action"),
                            data: $form.serialize(),
                            type: $form.attr("method") ? $form.attr("method").toUpperCase() : "GET",
                            success: function (data) {
                                $.each(data, function( key, obj ) {
                                    console.log(obj);
                                    if(obj.isReferenceUpdated) {
                                        ACC.colorbox.close();
                                        $(".edi-prod-ref").text(valueText).closest('.product-customer-reference-js').removeClass('hidden')

                                    } else {
                                        if(obj.attribute == "unique" || obj.attribute == "productReference") {
                                            $(".prod-ref").addClass("error");
                                            $(".errorRef").addClass("hidden");
                                            $(".unique-error").text(obj.message).removeClass("hidden");
                                        } else {
                                            $('#errorWsRef').removeClass('hidden')
                                            ACC.colorbox.open(title="", {
                                                href: ".errorWsRef",
                                                inline: true,
                                                width: "600px",
                                                height: "400px",
                                                onClosed: function() {
                                                    $('#errorWsRef').addClass('hidden')
                                                },
                                                onComplete: function () {
                                                    $(".js-btn-redirect").on("click", function () {
                                                        ACC.colorbox.close();
                                                    });
                                                },
                                            });
                                        }
                                    }
                                });
                            },
                            error: function () {
                              alert("Failed !!");
                            }
                        });
                    }
                    return false;
                });
                $(".js-pdp-btn-cancel").on("click", function (e) {
                    e.preventDefault();
                    ACC.colorbox.close();
                });
            },
        });
    },
};
